import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from '../../servicios/config/config.service';
import { DatatablesService } from '../../servicios/datatable/datatables.service';
import { FiltrosService } from '../../servicios/filtro/filtros.service';
import { KeyService } from '../../servicios/key.service';
import { SELECT2_FILTRO_AVANZADO } from '../../utilidades/constantes';
import { validarStringMultiple } from '../../utilidades/funciones';
import { RastreoService } from '../../servicios/rastreo/rastreo.service';
import swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OnDestroy } from '@angular/core/public_api';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-filtro-avanzado',
  templateUrl: './filtro-avanzado.component.html',
  styleUrls: ['./filtro-avanzado.component.css']
})
export class FiltroAvanzadoComponent implements OnInit, OnDestroy {

  @Output() formFiltrosEmit = new EventEmitter<any>();
  @Output() filtroInicial   = new EventEmitter<any>();

  PATH                = new ConfigService().obtenerPath();
  mostrarFiltro       : boolean = false;
  editarFiltro        : boolean = false;
  editandoFiltro      : boolean = false;
  formFiltros         : FormGroup;
  nombreFiltro        = new FormControl('');
  filtroSeleccionado  = new FormControl('');
  filtros             = [];
  dTFiltros           : any;
  headers             = {}
  dataFiltros         = {
      headfiltroid: [],
      clienteid: [],
      sucursalid: [],
      serial: [],
      fechacreacion: '',
      fechacierre: '',
      fechaIniLimite: '',
      fechaFinLimite: '',
      prioridadid: [],
      estadoid: [],
      servicioid: [],
      familiaid: [],
      marcaid: [],
      tipoadquisicionid: [],
      codigointerno: [],
      nombrcomer: [],
      tecnicoid: [],
      operacionid: [],
  };
 
  private destroy$ = new Subject();

  constructor(
    public  _filtro     : FiltrosService,
    private toastr      : ToastrService,
    private _datatable  : DatatablesService,
    private _key        : KeyService,
    private _rastreo   : RastreoService,
  ) {
    this.headers =  this._key.head2();
  }
  
  ngOnInit() {
    this.crearFormulario();
    const self = this;
    SELECT2_FILTRO_AVANZADO.forEach( n => {
      this.filtroSelectAvanzado(n.tipoFiltro)
    });

    this.obtenerFiltro();

    $('.favanzado').on('select2:unselect', (c) => {
      self.limpiarDataFiltros();
      self.recorrerInputsFiltros();
    });

  }

  filtroSelectAvanzado(tipoFiltro) {
    let self = this;
    $("." + tipoFiltro).select2({
      language : {
        noResults:function(){
          return 'No hay Resultado';
        },
        searching:function(){
          return 'Buscando..';
        },
        inputTooShort: function (){
          return 'Se necesitan mas de dos caracteres'
        },
      },
      tags: false,
      multiple: true,
      minimumInputLength: 2,
      ajax: {
          url: self.PATH + '/api/admin/filtroSelectAvanzado',
          dataType: "json",
          type: "POST",
          delay: 250,
          headers : self.headers,
          data: function (params) {
            self.recorrerInputsFiltros();
            let prueba = {
              searchTerm: params.term,// search term
              tipoFiltro, //tipo de fltro a solicitar
              cadenaFiltros : self.dataFiltros
            };
            // console.log(prueba);
            return prueba;
          },
          processResults: function (data) {
              return {
                  results: $.map(data.data, function (item) {
                      return {
                        text: item.text,
                        id: item.id
                      }
                  })
              };
          },
        }
    });
  }

  /**
  * Obtiene lista de filtros del usuario
  * Alexander Arenas 30-03-2023 
  **/
  obtenerFiltro() {
    this._filtro.obtenerFiltro(null, null, 'filtro', null).pipe(takeUntil(this.destroy$)).subscribe(resp => {
      let noTieneDefault = true;
      if (resp.data) {
        this.filtros = resp.data[0];
        this.filtros.forEach(f => {
          if (f.filtrodefault === '1') {
            noTieneDefault = false;
            this.filtroSeleccionado.setValue(f.headfiltroid);
            this.cambioFiltro(f.headfiltroid, true);
          } else {
            noTieneDefault = true;
          }
        });
        if (noTieneDefault) {
          this.filtroInicial.emit({ formFiltros: this.formFiltros.value, dataFiltros: this.dataFiltros});
        }
      }
    });
  }

  /**
  * Guarda nuevo filtro
  * Alexander Arenas 30-03-2023 
  **/
  guardarFiltros(tipo: string) {
    if (this.formFiltros.untouched && !this.recorrerInputsFiltros()) {
      this.toastr.error('Debe llenar minimo un campo', 'Error', { timeOut: 3000 });
    } else {
      var nuevoarray = [];
      $("#filtroAvanzado").find('.filtro').each(function(){
        if($(this).is("[multiple]")){
          for (let i=0; i < $(this).val().length; i++) {
            nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).select2('data')[i].id, texto: $(this).select2('data')[i].text});
          }
        }else{
          if($(this).val()){
            nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).val(), texto: null});
          }
        }
      })
      let nombreFiltro = '';
      swal({
      title: 'Digite nombre filtro',
      input: 'text',
      inputValue : $('#nombre').val(),
      inputAttributes: {
        maxlength     : '30',
        autocapitalize: 'off',
        autocorrect   : 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      showLoaderOnConfirm: true,
      preConfirm: (nombre) => {
        nombreFiltro = nombre;
        let data = {
          nombre : nombre,
          headfiltroid : $('#headfiltroid').val(),
        }

        var form_data = new FormData();
        for (var key in data) {
          form_data.append(key, data[key]);
        }

        let url = this.PATH+'/api/admin/validarNombre';
        let request = new Request(url,
          {
            method: 'POST',
            body : form_data,
            headers : new Headers(this.headers),
            mode: 'cors',
            credentials: 'omit',
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            cache: 'no-cache'
          });
        return fetch(
          request
        )
        .then(response => {
            return response.json().then(data => {
                if(data.data == 1){
                  swal.showValidationMessage(
                    `Verificar nombre: ${data.message}`
                  )
                }
            });
        })
        .catch(error => {
          swal.showValidationMessage(
            `Request failed : ${error}`
          )
        })
      },
      allowOutsideClick: () => !swal.isLoading()
      }).then(result => {
        if(result.value){
          let form = {
            data         : nuevoarray,
            modulo       : 'filtro',
            nombre       : nombreFiltro,
            headfiltroid : $('#headfiltroid').val()
          }
          this._filtro.crearFiltro(form).pipe(takeUntil(this.destroy$)).subscribe( resp => {
            if(resp.error) {
              this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
            } else {
              this.toastr.success('Transacción exitosa', '', { timeOut: 3000 });
              this.obtenerFiltro();
              if (this.dTFiltros) this.dTFiltros.ajax.reload();
            }
          })
        }
      });
    }
  }

  /**
  * Carga los valores cuando escogen un filtro diferente
  * Alexander Arenas 30-03-2023 
  **/
  cambioFiltro(data, filtroinicio: boolean) {
    this.crearFormulario();
    $(".favanzado").val('').trigger('change');
    this.formFiltros.controls.headfiltroid.setValue(data);
    this.formFiltros.disable();
    this._filtro.obtenerFiltro(data, null, 'filtro', null).pipe(takeUntil(this.destroy$)).subscribe(resp => {
      if (resp.data) {
        const dataFiltro = resp.data[1];
        for (let j = 0; j < dataFiltro.length; j++) {
          if(dataFiltro[j].headfiltroid == data){
            if( $('[data-modulo='+dataFiltro[j].campo+']').is("[multiple]")) {
              let newOption = new Option(dataFiltro[j].texto, dataFiltro[j].valor, true, true);
              $('[data-modulo='+dataFiltro[j].campo+']').append(newOption).trigger('change');
            } else {
              $('[data-modulo='+dataFiltro[j].campo+']').val(dataFiltro[j].valor).trigger('change');
              this.formFiltros.controls[''+dataFiltro[j].campo].setValue(dataFiltro[j].valor);
            }
          }
        }
        this.recorrerInputsFiltros();
        if (filtroinicio) {
          this.filtroInicial.emit({ formFiltros: this.formFiltros.value, dataFiltros: this.dataFiltros});
        } else if (filtroinicio == undefined && this.editandoFiltro == false) {
          this.formFiltrosEmit.emit({ formFiltros: this.formFiltros.value, dataFiltros: this.dataFiltros});
        }
      }
      this.formFiltros.enable();
    })
  }

  /**
  * Limpia todos los valores de inputs del filtro  
  * Alexander Arenas 30-03-2023 
  **/
  limpiarFiltros() {
    $(".favanzado").val(null).trigger('change');
    this.crearFormulario();
    this.dataFiltros  = {
      headfiltroid: [],
      clienteid: [],
      sucursalid: [],
      serial: [],
      fechacreacion: '',
      fechacierre: '',
      fechaIniLimite: '',
      fechaFinLimite: '',
      prioridadid: [],
      estadoid: [],
      servicioid: [],
      familiaid: [],
      marcaid: [],
      tipoadquisicionid: [],
      codigointerno: [],
      nombrcomer: [],
      tecnicoid: [],
      operacionid: [],
  };
  }

    /**
  * Limpia todos los valores de dataFiltros  
  * Alexander Arenas 18-09-2023 
  **/
  limpiarDataFiltros() {
    this.dataFiltros  = {
      headfiltroid: [],
      clienteid: [],
      sucursalid: [],
      serial: [],
      fechacreacion: '',
      fechacierre: '',
      fechaIniLimite: '',
      fechaFinLimite: '',
      prioridadid: [],
      estadoid: [],
      servicioid: [],
      familiaid: [],
      marcaid: [],
      tipoadquisicionid: [],
      codigointerno: [],
      nombrcomer: [],
      tecnicoid: [],
      operacionid: [],
    };
  }

  /**
  * Limpia todos los valores y emite valor para que se apliquen todos los filtros
  * Alexander Arenas 30-03-2023 
  **/
  todosFiltros() {
    $(".favanzado").val(null).trigger('change');
    this.crearFormulario();
    this.dataFiltros = {
      headfiltroid: [],
      clienteid: [],
      sucursalid: [],
      serial: [],
      fechacreacion: '',
      fechacierre: '',
      fechaIniLimite: '',
      fechaFinLimite: '',
      prioridadid: [],
      estadoid: [],
      servicioid: [],
      familiaid: [],
      marcaid: [],
      tipoadquisicionid: [],
      codigointerno: [],
      nombrcomer: [],
      tecnicoid: [],
      operacionid: [],
  };
    this.formFiltrosEmit.emit({ formFiltros: this.formFiltros.value, dataFiltros: this.dataFiltros});
  }

  /**
  * Emite valor para filtrar por filtros seleccionados  
  * Alexander Arenas 30-03-2023 
  **/
  filtrar() {
    this.recorrerInputsFiltros();
    this.formFiltrosEmit.emit({ formFiltros: this.formFiltros.value, dataFiltros: this.dataFiltros});
  }

  /**
  * Recorre todos los inputs del formulario para obtener su valor  
  * Alexander Arenas 30-03-2023 
  **/
  recorrerInputsFiltros() {
    let inputsConValor = false;
    if($("#clienteidFiltro").val().length > 0 && $("#clienteidFiltro").val() != null && $("#clienteidFiltro").val() != undefined){
      if($("#clienteidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.clienteid = "pq.terceroid in "+validarStringMultiple($("#clienteidFiltro").val());
        this.dataFiltros.clienteid = $("#clienteidFiltro").val();
      } 
    } else {
      this.formFiltros.value.clienteid = '';
    };

    if($("#sucursalidFiltro").val().length && $("#sucursalidFiltro").val() != null && $("#sucursalidFiltro").val() != undefined){
      if($("#sucursalidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.sucursalid = "pq.sucursalid in "+validarStringMultiple($("#sucursalidFiltro").val());
        this.dataFiltros.sucursalid = $("#sucursalidFiltro").val();
      }
    } else {
      this.formFiltros.value.sucursalid = '';
    };

    if($("#equipoSerialFiltro").val().length && $("#equipoSerialFiltro").val() != null && $("#equipoSerialFiltro").val() != undefined){
      if($("#equipoSerialFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.serial = "it.serial in "+validarStringMultiple($("#equipoSerialFiltro").val());
        this.dataFiltros.serial = $("#equipoSerialFiltro").val();
      }
    } else {
      this.formFiltros.value.serial = '';
    };

    // if($("#incidenciaidFiltro").val().length && $("#incidenciaidFiltro").val() != null && $("#incidenciaidFiltro").val() != undefined){
    //   if($("#incidenciaidFiltro").val().length > 0){
    //     inputsConValor = true;
    //     this.formFiltros.value.incidenciaid = "pq.pqrid in "+validarStringMultiple($("#incidenciaidFiltro").val());
    //   }
    // } else {
    //   this.formFiltros.value.incidenciaid = '';
    // };

    // if($("#ticketFiltro").val().length && $("#ticketFiltro").val() != null && $("#ticketFiltro").val() != undefined){
    //     if($("#ticketFiltro").val().length > 0){
    //       inputsConValor = true;
    //       this.formFiltros.value.ticket = "pq.ticket in "+validarStringMultiple($("#ticketFiltro").val());
    //     }
    // } else {
    //   this.formFiltros.value.ticket = '';
    // };
    
    if($("#prioridadidFiltro").val().length && $("#prioridadidFiltro").val() != null && $("#prioridadidFiltro").val() != undefined){
      if($("#prioridadidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.prioridadid = "pq.prioridadid in "+validarStringMultiple($("#prioridadidFiltro").val());
        this.dataFiltros.prioridadid = $("#prioridadidFiltro").val();
      }
    } else {
      this.formFiltros.value.prioridadid = '';
    };

    if($("#estadoidFiltro").val().length && $("#estadoidFiltro").val() != null && $("#estadoidFiltro").val() != undefined){
      if($("#estadoidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.estadoid = "pq.estadopqrid in "+validarStringMultiple($("#estadoidFiltro").val());
        this.dataFiltros.estadoid = $("#estadoidFiltro").val();
      }
    } else {
      this.formFiltros.value.estadoid = '';
    };

    if($("#servicioidFiltro").val().length && $("#servicioidFiltro").val() != null && $("#servicioidFiltro").val() != undefined){
      if($("#servicioidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.servicioid = "pq.tiposervicioid in "+validarStringMultiple($("#servicioidFiltro").val());
        this.dataFiltros.servicioid = $("#servicioidFiltro").val();
      }
    } else {
      this.formFiltros.value.servicioid = '';
    };
    
    if($("#familiaidFiltro").val().length && $("#familiaidFiltro").val() != null && $("#familiaidFiltro").val() != undefined){
      if($("#familiaidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.familiaid = "fa.familiaid in "+validarStringMultiple($("#familiaidFiltro").val());
        this.dataFiltros.familiaid = $("#familiaidFiltro").val();
      }
    } else {
      this.formFiltros.value.familiaid = '';
    };
    
    if($("#marcaidFiltro").val().length && $("#marcaidFiltro").val() != null && $("#marcaidFiltro").val() != undefined){
      if($("#marcaidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.marcaid = "ma.marcaid in "+validarStringMultiple($("#marcaidFiltro").val());
        this.dataFiltros.marcaid = $("#marcaidFiltro").val();
      }
    } else {
      this.formFiltros.value.marcaid = '';
    };

    if($("#tipoadquisicionidFiltro").val().length && $("#tipoadquisicionidFiltro").val() != null && $("#tipoadquisicionidFiltro").val() != undefined){
      if($("#tipoadquisicionidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.tipoadquisicionid = "it.tipoadquisicionid in "+validarStringMultiple($("#tipoadquisicionidFiltro").val());
        this.dataFiltros.tipoadquisicionid = $("#tipoadquisicionidFiltro").val();
      }
    } else {
      this.formFiltros.value.tipoadquisicionid = '';
    };

    if($("#codigointernoFiltro").val().length && $("#codigointernoFiltro").val() != null && $("#codigointernoFiltro").val() != undefined){
      if($("#codigointernoFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.codigointerno ="it.itemequipoid in "+validarStringMultiple($("#codigointernoFiltro").val());
        this.dataFiltros.codigointerno = $("#codigointernoFiltro").val();
      }
    } else {
      this.formFiltros.value.codigointerno = '';
    };

    if($("#nombrcomerFiltro").val().length && $("#nombrcomerFiltro").val() != null && $("#nombrcomerFiltro").val() != undefined){
      if($("#nombrcomerFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.nombrcomer = "te.nombrcomer in "+validarStringMultiple($("#nombrcomerFiltro").val());
        this.dataFiltros.nombrcomer = $("#nombrcomerFiltro").val();
      }
    } else {
      this.formFiltros.value.nombrcomer = '';
    };

    if($("#tecnicoidFiltro").val().length && $("#tecnicoidFiltro").val() != null && $("#tecnicoidFiltro").val() != undefined){
      if($("#tecnicoidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.tecnicoid = "tc.tecnicoid in "+validarStringMultiple($("#tecnicoidFiltro").val());
        this.dataFiltros.tecnicoid = $("#tecnicoidFiltro").val();
      }
    } else {
      this.formFiltros.value.tecnicoid = '';
    };

    if($("#operacionidFiltro").val().length && $("#operacionidFiltro").val() != null && $("#operacionidFiltro").val() != undefined){
      if($("#operacionidFiltro").val().length > 0){
        inputsConValor = true;
        this.formFiltros.value.operacionid = "op.operacionid in "+validarStringMultiple($("#operacionidFiltro").val());
        this.dataFiltros.operacionid = $("#operacionidFiltro").val();
      }
    } else {
      this.formFiltros.value.operacionid = '';
    };

    this.dataFiltros.fechacreacion = this.formFiltros.value.fechacreacion;
    this.dataFiltros.fechacierre = this.formFiltros.value.fechacierre;
    this.dataFiltros.fechaIniLimite = this.formFiltros.value.fechaIniLimite;
    this.dataFiltros.fechaFinLimite = this.formFiltros.value.fechaFinLimite;


    return inputsConValor;
  }

  /**
  * Vulve a la vista donde esta el formulario  
  * Alexander Arenas 30-03-2023 
  **/
  cancelarVerTablaFiltros() {
    this.editarFiltro = !this.editarFiltro;
  }

  /**
  * Carga tabla para ver, editar y eliminar filtros creados por el usuario  
  * Alexander Arenas 30-03-2023 
  **/
  cargarTablaFiltros() {
    const self = this;
    this.editarFiltro = !this.editarFiltro;
    this.dTFiltros = $('#dTFiltroAvanzado').DataTable( {
      dom: "domBtrlp",
      destroy: true,
      scrollX: true,
      language: self._datatable.language(),
      order : [[1,'desc']],
      buttons: self._datatable.buttons(),
      lengthChange :true,
      processing: true,
      serverSide: true,
      ajax: {
        url: self.PATH + '/api/admin/ListaFiltro',
        type: 'POST',
        headers : self.headers,
        data : function(d){
          return  $.extend(d,{modulo:'filtro'});
        },
      },
      columns: [
        { data: "headfiltroid" },
        { data: "nombre" },
        { data: "usuarioid" },
        { data: "filtrodefault", width: '1%' },
      ],
      initComplete: function(settings, json){
        var self = this;
        $(this).closest('.dataTables_wrapper').find('div.dataTables_filter input').unbind().keyup( function (e) {
          e.preventDefault();
          if (e.keyCode == 13) {
            self.dtTblIncidencia = $("body").find(self.dtTblIncidencia).dataTable();
            self.dtTblIncidencia.fnFilter( this.value );
            self.fnFilter(this.value);
          };
        } );
        $('div.dataTables_filter input').focus();
      },
      columnDefs: [
        {
          targets 	: [0],
          width 		: '1%',
          order     : false,
          className : 'center'
        },
        {
          targets 	: [1],
          width 		: '50%',
          order     : true,
          className : 'center'
        }
      ],
      rowCallback : function(row,data){
        let btnEditar          = '';
        let btnEliminar        = '';

        btnEliminar = '<a class="btnEliminar btn btn-danger glyphicon glyphicon-remove" type="submit" style="width:30px; padding:1px;"></a>';
        btnEditar   = '<a class="btnEditar btn btn-success glyphicon glyphicon-pencil" type="submit" title="Editar Incidencia"  style="width:30px; padding:1px;"></a>';

        $(row).find('td:eq(0)').html( btnEditar + ' ' + btnEliminar);
        $(row).find('.btnEliminar').on("click", function(e){
          e.preventDefault();

          $(row).on("click", ".btnEliminar", function(e){
            e.preventDefault();
            self.eliminarFiltro(data.headfiltroid,data.nombre)
          });
        });

        $(row).find('.btnEditar').on("click", function(e){
          $("#dttableFiltro").addClass('hide');
          $(".clasbtnFiltro").removeClass('hide');
          self.onEditarFiltro(data.headfiltroid);
          self.nombreFiltro.setValue(data.nombre);
        });

      },
      createdRow: function(row, data, index){
      },
    });
  }

  /**
  * Carga los datos de un filtro para editarlo  
  * Alexander Arenas 30-03-2023 
  **/
  onEditarFiltro(headfiltroid) {
    this.cambioFiltro(headfiltroid, false);
    this.editandoFiltro = !this.editandoFiltro;
    this.editarFiltro = !this.editarFiltro;
  }

  /**
  * Guarda los datos del filtro editado 
  * Alexander Arenas 30-03-2023 
  **/
  guardarFiltroEditado() {
    if (this.formFiltros.untouched && !this.recorrerInputsFiltros()) {
      this.toastr.error('Debe llenar minimo un campo', 'Error', { timeOut: 3000 });
    } else {
      var nuevoarray = [];
      $("#filtroAvanzado").find('.filtro').each(function(){
        if($(this).is("[multiple]")){
          for (let i=0; i < $(this).val().length; i++) {
            nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).select2('data')[i].id, texto: $(this).select2('data')[i].text});
          }
        }else{
          if($(this).val()){
            nuevoarray.push({campo:$(this).attr('data-modulo'), valor: $(this).val(), texto: null});
          }
        }
      });
      let form = {
        data         : nuevoarray,
        modulo       : 'filtro',
        nombre       : this.nombreFiltro.value,
        headfiltroid : $('#headfiltroid').val()
      }
      this._filtro.editarFiltro(form).subscribe( resp => {
        if (resp.error) {
          this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
        } else {
          this.toastr.success(resp.message, '', { timeOut: 3000 });
          this.editandoFiltro = !this.editandoFiltro;
        }
      })
    }
  }

  /**
  * Cancela la edición del filtro 
  * Alexander Arenas 30-03-2023 
  **/
  cancelarEdicionFiltro() {
    this.editandoFiltro = !this.editandoFiltro;
  }

  /**
  * Actualiza filtro por defecto 
  * Alexander Arenas 30-03-2023 
  **/
  dejarFiltroPorDefecto() {
    this._filtro.updateDefaultFiltro({ headfiltroid: this.formFiltros.value.headfiltroid }).subscribe( resp => {
      if (resp.error) {
        this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
      } else {
        this.toastr.success(resp.message, 'Filtro por defecto guardado con exito', { timeOut: 3000 });
        this.editandoFiltro = !this.editandoFiltro;
      }
    })
  }

  /**
  * Elimina el filtro desde la tabla 
  * Alexander Arenas 30-03-2023 
  **/
  eliminarFiltro(headFiltroid, nombre) {
    swal({
      title: 'Esta seguro de eliminar el registro?',
      text: "",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this._filtro.destroy(headFiltroid).pipe(takeUntil(this.destroy$)).subscribe((resp) => {
          if (resp.error) {
            this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          } else {
            //rastreo
            let opcionEnviar = 'Elimina Filtro: Codigo: '+ headFiltroid + ' Nombre: '+ nombre;
            this._rastreo.setRastreo(opcionEnviar,'Tipo Instalacion').subscribe((resp)=>{
            })//fin rastreo
            this.toastr.success(resp.message, '', { timeOut: 3000 });
            this.dTFiltros.ajax.reload();
          }
        });
      }
    });
    this.dTFiltros.ajax.reload();
    this.obtenerFiltro();
  }

  /**
  * Crea el formulario de los filtros  
  * Alexander Arenas 30-03-2023 
  **/
  crearFormulario() {
    this.formFiltros = new FormGroup({
      headfiltroid: new FormControl(''),
      clienteid: new FormControl(''),
      sucursalid: new FormControl(''),
      serial: new FormControl(''),
      incidenciaid: new FormControl(''),
      ticket: new FormControl(''),
      fechacreacion: new FormControl(''),
      fechacierre: new FormControl(''),
      fechaIniLimite: new FormControl(''),
      fechaFinLimite: new FormControl(''),
      prioridadid: new FormControl(''),
      estadoid: new FormControl(''),
      servicioid: new FormControl(''),
      familiaid: new FormControl(''),
      marcaid: new FormControl(''),
      tipoadquisicionid: new FormControl(''),
      codigointerno: new FormControl(''),
      nombrcomer: new FormControl(''),
      tecnicoid: new FormControl(''),
      operacionid: new FormControl(''),
      tipoincfiltro: new FormControl('0'),
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/filtro-avanzado/filtro-avanzado.component.ts